
/**
 *
 * @param el {HTMLElement}
 * @returns {boolean}
 */
export function isDomElementVisible(el) {
  return (el).offsetParent !== null && el.offsetWidth;
}

export function simpleStringify (object){
  if (object && typeof object === 'object') {
    object = copyWithoutCircularReferences([object], object);
  }
  return JSON.stringify(object);

  function copyWithoutCircularReferences(references, object) {
    var cleanObject = {};
    Object.keys(object).forEach(function(key) {
      var value = object[key];
      if (value && typeof value === 'object') {
        if (references.indexOf(value) < 0) {
          references.push(value);
          cleanObject[key] = copyWithoutCircularReferences(references, value);
          references.pop();
        } else {
          cleanObject[key] = '###_Circular_###';
        }
      } else if (typeof value !== 'function') {
        cleanObject[key] = value;
      }
    });
    return cleanObject;
  }
}

export var dzs_open_social_link = function(arg,argthis){
  var leftPosition, topPosition;
  var w = 500, h= 500;
  leftPosition = (window.screen.width / 2) - ((w / 2) + 10);
  topPosition = (window.screen.height / 2) - ((h / 2) + 50);
  var windowFeatures = "status=no,height=" + h + ",width=" + w + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";






  arg = arg.replace('{{replacewithcurrurl}}',encodeURIComponent(window.location.href));
  if(argthis){

    arg = arg.replace(/{{replacewithdataurl}}/g,argthis.attr('data-url'));
  }

  var aux = window.location.href;


  var auxa = aux.split('?');

  var cid = '';
  var cid_gallery = '';

  if(argthis){
    if(jQuery(argthis).parent().parent().attr('data-menu-index')){

      cid = jQuery(argthis).parent().parent().attr('data-menu-index');
    }
    if(jQuery(argthis).parent().parent().attr('data-gallery-id')){

      cid_gallery = jQuery(argthis).parent().parent().attr('data-gallery-id');
    }
  }

  arg = arg.replace('{{shareurl}}',encodeURIComponent(auxa[0]+'?audiogallery_startitem_'+cid_gallery+'='+cid));

  window.open(arg,"sharer", windowFeatures);
};




export const remove_query_arg_all = function (purl){

  var fout = purl.split('&')[0];
  fout = fout.split('?')[0];


  return fout;

}
export const add_query_args = function add_query_args(purl, keys){

  var fout = purl;
  var ind = 0;
  for(var key in keys){


    if(keys[key]){
      if(ind){
        fout+='&';
      }else{

        fout+='?';
      }

      var key_lab = key;

      if(key==='post_type'){
        key_lab = 'post_type_2';
      }



      fout+=key_lab+'='+encodeURIComponent(keys[key]);
      ind++;
    }

  }

  return fout;
}

export function convertPluginOptionsToFinalOptions (elThis, defaultOptions, argOptions = null, searchedAttr = 'data-options', searchedDivClass = 'feed-options') {

  var finalOptions = null;
  var tempOptions = {};
  var sw_setFromJson = false;
  var _elThis = jQuery(elThis);

  if (argOptions && typeof argOptions == 'object') {
    tempOptions = argOptions;
  } else {

    if (_elThis.attr(searchedAttr)) {
      try {
        tempOptions = JSON.parse(_elThis.attr(searchedAttr));
        sw_setFromJson = true;
      } catch (err) {
        console.log('json parse error searched attr err - ', err, _elThis.attr(searchedAttr));
      }
    } else {

      if (_elThis.find('.feed-options').length) {
        try {
          tempOptions = JSON.parse(_elThis.find('.feed-options').html());
          sw_setFromJson = true;
        } catch (err) {
          console.log('json parse error feed-options err - ', err, _elThis.find('.feed-options').html());
        }
      }
    }
  }

  finalOptions = Object.assign(defaultOptions, tempOptions);

  return finalOptions;
}


export const get_query_arg = function get_query_arg(purl, key){
  if (purl.indexOf(key + '=') > -1) {


    var regexS = '(?:\\?|\\&)'+key+'=(.*?)(?=&|$)';
    var regex = new RegExp(regexS);
    var regtest = regex.exec(purl);

    if (regtest && regtest[1]) {
      return regtest[1];
    }
  }
  return '';
}

export const get_query_arg_all = (purl) => {



  var arr = {};
  if(purl.indexOf('=')>-1){

    var regex = /[?|&](.*?)=(.*?)(?=&|$)/g;

    var aux = null;
    while(aux = regex.exec(purl)){




      let urlValue = aux[2].replace( /\+/g, ' ' );

      arr[aux[1]] = decodeURI(urlValue);

    }
  }

  return arr;
}

export const add_query_arg = function add_query_arg(purl, key,value){
  key = encodeURIComponent(key); value = encodeURIComponent(value);


  var s = purl;
  var pair = key+"="+value;

  var r = new RegExp("(&|\\?)"+key+"=[^\&]*");



  s = s.replace(r,"$1"+pair);
  var addition = '';


  if(s.indexOf(key + '=')>-1){


  }else{
    if(s.indexOf('?')>-1){
      addition = '&'+pair;
    }else{
      addition='?'+pair;
    }
    s+=addition;
  }

  //if value NaN we remove this field from the url
  if(value=='NaN'){
    var regex_attr = new RegExp('[\?|\&]'+key+'='+value);
    s=s.replace(regex_attr, '');
  }



  return s;
}


/**
 *
 * @param {string} scriptSrc if no script src - it will just look for var
 * @param {string} checkForVar must be on window property
 * @returns {Promise<any>}
 */
export const loadScriptIfItDoesNotExist = (scriptSrc, checkForVar) => {
  const CHECK_INTERVAL = 50;
  const TIMEOUT_MAX = 5000;
  let checkInterval = 0;
  const loadScript = (scriptSrc, resolve, reject) => {
    var script = document.createElement('script');
    script.onload = function () {
      resolve('loadfromload');
    };
    script.onerror = function () {
      reject();
    };
    script.src = scriptSrc;
    document.head.appendChild(script);
  }

  return new Promise((resolve, reject) => {
    let isAlreadyLoaded = false;
    let isGoingToLoadScript = false;

    /**
     *
     * @returns {boolean}
     */
    function checkIfVarExists() {
      if (window[checkForVar]) {
        clearInterval(checkInterval);
        resolve('loadfromvar');
        return true;
      }
      return false;
    }

    isAlreadyLoaded = checkIfVarExists();
    if (!isAlreadyLoaded) {
      isGoingToLoadScript = true;

      if(checkForVar){
        checkInterval = setInterval(checkIfVarExists, CHECK_INTERVAL);
      }

      setTimeout(() => {
        clearInterval(checkInterval);
        reject('timeout');
      }, TIMEOUT_MAX);
    }
    if (!checkForVar) {
      isGoingToLoadScript = true;
    }
    if (!scriptSrc) {
      isGoingToLoadScript = false;
    }

    if (isGoingToLoadScript) {
      clearInterval(checkInterval);
      loadScript(scriptSrc, resolve, reject);
    }

  })
}